import { useState } from 'react';

import { Toaster as SonnerToaster } from './sonner/index.jsx';

export const Toaster = () => {
  const [isUnfoldedView, setIsUnfoldedView] = useState(false);

  const handleMouseEnter = () => {
    setIsUnfoldedView(true);
  };

  const handleMouseLeave = () => {
    setIsUnfoldedView(false);
  };

  const visibleToasts = isUnfoldedView ? 50 : 3;
  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <SonnerToaster
        visibleToasts={visibleToasts}
        position="bottom-right"
        className='pb-safe pr-safe data-[y-position="bottom"]:right-[24px]! data-[y-position="bottom"]:bottom-[92px]!'
      />
    </div>
  );
};
